/*
 * Safe from XSS dom parser, use only text content.
 * Return text, when there is no html text content.
 * */
import unescape from "lodash/unescape"

export const textDomParser = (text: string): string => {
    const parser = new DOMParser()
    const unescapedText = unescape(text)

    return parser.parseFromString(unescapedText, "text/html").body.textContent ?? ""
}
